import React from 'react';

import Icon from './';

export default Icon(() => (
    <path d="M5.9,15.7h2.4c0,1.3,1.7,2.4,3.7,2.4s3.7-1.1,3.7-2.4c0-1.3-1.3-1.8-4-2.5c-2.6-0.6-5.8-1.5-5.8-4.9c0-2.2,1.8-4,4.3-4.7V1h3.7v2.7c2.5,0.6,4.3,2.5,4.3,4.7h-2.4C15.7,7,14,5.9,12,5.9S8.3,7,8.3,8.3c0,1.3,1.3,1.8,4,2.5c2.6,0.6,5.8,1.5,5.8,4.9c0,2.2-1.8,4-4.3,4.7V23h-3.7v-2.7C7.7,19.7,5.9,17.9,5.9,15.7z" />
));
